exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-lg img {\r\n    width: 179px;\r\n}\r\n\r\n#navbar .navbar-nav>li>.notification_dropdown {\r\n    margin-top: -5px;\r\n    width: 350px;\r\n    background: #f1f1f1;\r\n    position: absolute;\r\n    left: -185px;\r\n}\r\n.notification_dropdown{\r\n     padding-top: 0px;\r\n     padding-bottom: 0px;\r\n}\r\n.notification_dropdown li{\r\n     padding: 20px;\r\n     border-bottom: 1px solid #b9b9bb;\r\n     border-bottom-left-radius: 5px;\r\n     border-bottom-right-radius: 5px;\r\n}\r\n.notification_dropdown li:hover{\r\n     background: white;\r\n     cursor: pointer;\r\n}\r\n.notification_dropdown li:last-child{\r\n     border-bottom: none;\r\n}\r\n.notification_dropdown li a{\r\n     color: #0a0a0a\r\n}\r\n.notification_dropdown li span {\r\n     display: inline-block;\r\n     width: 30%;\r\n     font-weight: bold;\r\n}\r\n.notification_dropdown li span:first{\r\n     float: left;\r\n}\r\n.notification_dropdown li span:nth-child(2){\r\n     text-align: center;\r\n     width: 40%;\r\n}\r\n.notification_dropdown li span:last-child{\r\n     float: right;\r\n     width: 25%;\r\n     text-align: right;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.css
// module id = 387
// module chunks = 1